(() => {
  'use strict';

  /**
   * Nip2Lip motion — scroll reveals + streetwear interaction polish.
   * Decorative only; does not touch forms, cart, or checkout.
   */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.dataset.n2lMotionBound === 'true') return;
  document.documentElement.dataset.n2lMotionBound = 'true';

  const revealSel = [
    '.n2l-section__head',
    '.n2l-product-card',
    '.n2l-archive-card',
    '.n2l-archive-entry',
    '.n2l-campaign-feature__media',
    '.n2l-campaign-feature__copy',
    '.n2l-story__copy',
    '.n2l-story__media',
    '.n2l-one-done-strip',
    '.n2l-access__inner',
    '.n2l-hero__panel',
    '.n2l-hero__media',
    '.n2l-vip__copy',
    '.n2l-vip__media',
    '.n2l-account__panel',
    '.n2l-account__dash-card',
    '.n2l-account__header',
    '.n2l-account-guest',
    '.n2l-contact__inner',
    '.n2l-about-hero__copy',
    '.n2l-about-hero__media',
    '.n2l-about-page .n2l-reveal',
  ].join(',');

  const nodes = Array.from(document.querySelectorAll(revealSel));
  if (!nodes.length) return;

  nodes.forEach((el, i) => {
    el.classList.add('n2l-reveal');
    el.style.setProperty('--n2l-reveal-delay', `${Math.min((i % 6) * 60, 240)}ms`);
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('n2l-reveal--in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  nodes.forEach((el) => io.observe(el));

  // Ticker pause on hover/focus (CSS also handles hover)
  document.querySelectorAll('.n2l-ticker').forEach((ticker) => {
    ticker.addEventListener('mouseenter', () => ticker.classList.add('is-paused'));
    ticker.addEventListener('mouseleave', () => ticker.classList.remove('is-paused'));
  });
})();
